import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import { useQuery } from "@tanstack/react-query";
import { TextField } from "@material-ui/core";
import { fetchEventos } from "../../../../shared/fetchers/classics/eventos/verEventos";
import CrearEventoIndividual from "../crear-evento/crear-evento-individual";

const EditarEvento = () => {
  const [evento, setEvento] = useState(null);

  const {
    data: eventos,
    isLoading,
    isError,
  } = useQuery(["eventos"], fetchEventos);

  if (isLoading)
    return (
      <>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </>
    );

  if (isError)
    return <div>Ha ocurrido un error, prueba recargando la página</div>;

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <CreateOutlinedIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Editar un evento</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <label className="admin-label-text mt-3 d-block">
              Selecciona un evento para editarlo
            </label>
            <Autocomplete
              options={eventos}
              value={evento}
              disabled={Boolean(evento)}
              getOptionLabel={(option) => `${option.nombreEsp}`}
              onChange={(_, newValue) => {
                setEvento(newValue);
              }}
              noOptionsText="Sin resultados"
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  style={{
                    width: "100%",
                    fontFamily: "'Noto Sans JP', sans-serif",
                  }}
                />
              )}
            />
          </Col>

          {evento && (
            <CrearEventoIndividual
              evento={{ ...evento}}
              clearEdit={() => setEvento(null)}
            />
          )}
        </Row>
      </Container>
    </>
  );
};

export default EditarEvento;
